import { InputHTMLAttributes, useState } from "react";

import { Icon } from "@wevideo/uikit3/primitives/Icon";

import "./PasswordInput.scss";

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, "type">;

const PasswordInput = ({ className, ...rest }: Props) => {
	const [showPassword, setShowPassword] = useState(false);

	return (
		<div className="password-input-wrapper">
			<input
				{...rest}
				type={showPassword ? "text" : "password"}
				className={className ? `fs-hide ${className}` : "fs-hide"}
			/>
			<span
				role="button"
				tabIndex={0}
				className="password-input-toggle"
				onClick={() => setShowPassword(prev => !prev)}
				onKeyDown={event => {
					if (event.key === "Enter" || event.key === " ") {
						event.preventDefault();
						setShowPassword(prev => !prev);
					}
				}}
				aria-label={showPassword ? "Hide password" : "Show password"}
			>
				{showPassword ? (
					<Icon name="eye-off" size={20} aria-hidden />
				) : (
					<Icon name="eye" size={20} aria-hidden />
				)}
			</span>
		</div>
	);
};

export { PasswordInput };
